import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { AlertOctagon, CheckCircle2 } from 'lucide-react';
import api from '../../lib/api';
import { Button } from '../ui/button';

export const SevereReactionBanner = () => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get('/staff/portal/adverse-reactions/severe-clusters')
    .then(({ data }) => setRows(data.clusters || [])).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);

  const review = async (c) => {
    try {
      await api.post('/staff/portal/adverse-reactions/severe-clusters/review', { cluster_key: c.cluster_key });
      toast.success(`Marked ${c.medicine_name} batch ${c.batch_number} as reviewed`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Only a pharmacist who manages patients can mark this reviewed'); }
  };

  if (!rows.length) return null;
  return (
    <div className="rounded-2xl border border-red-300 bg-red-600 text-white p-4 space-y-2 shadow-sm" role="alert" data-testid="severe-reaction-banner">
      {rows.map((c) => (
        <div key={c.cluster_key} className="flex flex-wrap items-center gap-3" data-testid={`severe-reaction-cluster-${c.cluster_key}`}>
          <AlertOctagon className="h-5 w-5 shrink-0" />
          <p className="flex-1 min-w-[220px] text-sm">
            <b>{c.count} severe reactions</b> reported for <b>{c.medicine_name}</b> batch <b className="font-mono">{c.batch_number}</b>
            {c.previously_reviewed_at && ' — new report since it was last reviewed'}. Check the stock and consider a recall.
          </p>
          <Button asChild size="sm" variant="secondary" className="h-8" data-testid={`severe-reaction-open-${c.cluster_key}`}>
            <Link to="/customers/reactions">See reports</Link>
          </Button>
          <Button size="sm" variant="outline" className="h-8 bg-transparent text-white border-white/60 hover:bg-white/10 hover:text-white"
            onClick={() => review(c)} data-testid={`severe-reaction-review-${c.cluster_key}`}>
            <CheckCircle2 className="h-4 w-4 mr-1" /> Mark reviewed
          </Button>
        </div>
      ))}
    </div>
  );
};
